$(document).on("turbolinks:load", common_events);
$(document).on("turbolinks:before-cache", function () {
  $(".js-basic-single").select2("destroy");
});

function common_events() {
  // pagination
  $(window).on("scroll", function () {
    if ($(window).scrollTop() + $(window).height() === $(document).height()) {
      let url = $(".paginate-notification .pagination .next a").attr("href");

      if (url) {
        $.ajax({
          type: "GET",
          url: url,
          dataType: "script",
          success: function () {
            $(".loader").fadeOut(500);
          },
        });
      }
    }
  });

  $(".notification-back-btn").on("click", function () {
    history.back();
  });
}
